import {
  LayoutGrid,
  Calendar,
  FolderOpen,
  Square,
  Video,
  MapPin,
  Camera,
  Cpu,
  Film,
  Radio,
  Scissors,
  Bot,
  BarChart3,
  TrendingUp,
  // Sparkles,
} from "lucide-react";
import type { HardcodedNavSection } from "./types";
import { EVENTS_PAGE_PATH } from "../../routes/paths";

export const HARDCODED_NAV_SECTIONS: HardcodedNavSection[] = [
  {
    source: "hardcoded",
    id: "dashboard",
    title: "Dashboard",
    collapsedTitle: "Dashboard",
    icon: LayoutGrid,
    isSectionActive: (p) =>
      p === "/" || p === EVENTS_PAGE_PATH || p === "/camera-status" || p === "/ai-status",
    children: [
      { to: "/", end: true, label: "Overview", icon: LayoutGrid },
      { to: EVENTS_PAGE_PATH, label: "Events", icon: Calendar },
    ],
  },
  {
    source: "hardcoded",
    id: "cmm",
    title: "Camera Management Module",
    collapsedTitle: "Cmm",
    icon: FolderOpen,
    module: "cmm",
    isSectionActive: (p) => p.startsWith("/cmm"),
    children: [
      { to: "/cmm/zone", label: "Configure ROI", icon: Square, module: "cmm", feature: "configure-roi" },
      { to: "/cmm/ptz", label: "PTZ Control", icon: Video, module: "cmm", feature: "ptz-control" },
      { to: "/cmm/locations", label: "Locations", icon: MapPin, module: "cmm", feature: "locations" },
      { to: "/cmm/camera", label: "Camera", icon: Camera, module: "cmm", feature: "camera" },
      { to: "/cmm/gpu", label: "GPUs", icon: Cpu, module: "cmm", feature: "gpus" },
    ],
  },
  {
    source: "hardcoded",
    id: "nvr",
    title: "Video Management System",
    collapsedTitle: "VMS",
    icon: Film,
    module: "vms",
    isSectionActive: (p) =>
      p.startsWith("/nvr-live") || p.startsWith("/nvr-recording") || p.startsWith("/nvr-clip"),
    children: [
      { to: "/nvr-live", label: "Live Streaming", icon: Radio, module: "vms", feature: "live-streaming" },
      { to: "/nvr-recording", label: "Recordings", icon: Film, module: "vms", feature: "recordings" },
      { to: "/nvr-clip", label: "Find Clip", icon: Scissors, module: "vms", feature: "find-clip" },
    ],
  },
  {
    source: "hardcoded",
    id: "ai-analytics",
    title: "AI Analytics",
    collapsedTitle: "AI",
    icon: BarChart3,
    module: "ai-analytics",
    isSectionActive: (p) => p.startsWith("/ai-analytics"),
    children: [
      {
        to: "/ai-analytics/student-distribution",
        label: "Distribution",
        icon: TrendingUp,
        module: "ai-analytics",
        feature: "distribution",
      },
      // { to: "/ai-analytics/hyzine", label: "Cleaning & Hygiene", icon: Sparkles },
    ],
  },
  {
    source: "hardcoded",
    id: "agent",
    title: "Agent",
    collapsedTitle: "Agent",
    icon: Bot,
    module: "agent",
    isSectionActive: (p) => p === "/video-agent",
    children: [
      {
        to: "/video-agent",
        label: "Video",
        icon: Video,
        module: "agent",
        feature: "video",
        overrideMatchTab: "agent",
        overrideMatchSubTab: "Video",
      },
    ],
  },
];
